import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import React from 'react';

interface PartnerTableHeaderProps {
  searchTerm: string;
  setSearchTerm: (_value: string) => void;
}

export const PartnerTableHeader: React.FC<PartnerTableHeaderProps> = ({
  searchTerm,
  setSearchTerm,
}) => (
  <div className="space-y-4 gap-2 lg:space-y-0 lg:flex lg:items-center lg:justify-between">
    <div className="space-y-2">
      <h2 className="text-xl font-semibold leading-6 text-gray-900 sm:text-xl lg:text-2xl">
        Marcas
      </h2>
      <p className="text-sm text-muted-foreground sm:text-base max-w-2xl">
        Gerencie marcas e clientes vinculados. Clique em uma marca para ver os clientes.
      </p>
    </div>
    <div className="flex flex-col space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3 lg:flex-shrink-0">
      <div className="relative flex-1 sm:flex-none sm:w-64 lg:w-72">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        <Input
          placeholder="Procurar marcas..."
          value={searchTerm}
          className="w-full h-10 sm:h-9"
          iconLeft={<Search className="h-4 w-4 stroke-muted-foreground" />}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
    </div>
  </div>
);
